import { Button } from '@windmill/react-ui';
import React, { useState } from 'react'
import ImageHero from '../assets/img/home/book_magic.jpeg'
import ImageTool from '../assets/img/home/cat.jpeg'

function Navbar(props) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  return (
    <>
      <nav
        className={
          (props.transparent
            ? "top-0 absolute z-50 w-full"
            : "relative shadow-lg bg-white shadow-lg") +
          " flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg"
        }
      >
        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <a
              className={
                (props.transparent ? "text-white" : "text-gray-800") +
                " text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-no-wrap uppercase"
              }
              href="#signup"
            >
              Noctli
            </a>
            <button
              className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <i
                className={
                  (props.transparent ? "text-white" : "text-gray-800") +
                  " fas fa-bars"
                }
              ></i>
            </button>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center bg-white lg:bg-transparent lg:shadow-none" +
              (navbarOpen ? " block rounded shadow-lg" : " hidden")
            }
            id="example-navbar-warning"
          >
            <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
              <li className="flex items-center">
                <a
                  className={
                    (props.transparent
                      ? "bg-white text-gray-800 active:bg-gray-100"
                      : "bg-pink-500 text-white active:bg-pink-600") +
                    " text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3"
                  }
                  type="button"
                  style={{ transition: "all .15s ease" }}
                  href="#signup"
                >
                  Signup
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

// function Footer() {
//   return (
//     <>
//       <footer className="relative bg-gray-300 pt-8 pb-6">
//         <div
//           className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
//           style={{ height: "80px", transform: "translateZ(0)" }}
//         >
//           <svg
//             className="absolute bottom-0 overflow-hidden"
//             xmlns="http://www.w3.org/2000/svg"
//             preserveAspectRatio="none"
//             version="1.1"
//             viewBox="0 0 2560 100"
//             x="0"
//             y="0"
//           >
//             <polygon
//               className="text-gray-300 fill-current"
//               points="2560 0 2560 100 0 100"
//             ></polygon>
//           </svg>
//         </div>
//         <div className="container mx-auto px-4">
//           <div className="flex flex-wrap">
//             <div className="w-full lg:w-6/12 px-4">
//               <h4 className="text-3xl font-semibold">
//                 Let's keep in touch!
//               </h4>
//               <h5 className="text-lg mt-0 mb-2 text-gray-700">
//                 Find us on any of these platforms, we respond 1-2 business days.
//               </h5>
//               <div className="mt-6">
//                 <button
//                   className="bg-white text-blue-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2 p-3"
//                   type="button"
//                 >
//                   <i className="flex fab fa-twitter"></i>
//                 </button>
//                 <button
//                   className="bg-white text-blue-600 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2 p-3"
//                   type="button"
//                 >
//                   <i className="flex fab fa-facebook-square"></i>
//                 </button>
//                 <button
//                   className="bg-white text-pink-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2 p-3"
//                   type="button"
//                 >
//                   <i className="flex fab fa-dribbble"></i>
//                 </button>
//                 <button
//                   className="bg-white text-gray-900 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2 p-3"
//                   type="button"
//                 >
//                   <i className="flex fab fa-github"></i>
//                 </button>
//               </div>
//             </div>
//             <div className="w-full lg:w-6/12 px-4">
//               <div className="flex flex-wrap items-top mb-6">
//                 <div className="w-full lg:w-4/12 px-4 ml-auto">
//                   <span className="block uppercase text-gray-600 text-sm font-semibold mb-2">
//                     Useful Links
//                   </span>
//                   <ul className="list-unstyled">
//                     <li>
//                       <a className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
//                          href="https://www.creative-tim.com/presentation">About Us
//                       </a>
//                     </li>
//                     <li>
//                       <a className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
//                          href="https://blog.creative-tim.com">Blog
//                       </a>
//                     </li>
//                     <li>
//                       <a className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
//                          href="https://www.github.com/creativetimofficial">Github
//                       </a>
//                     </li>
//                     <li>
//                       <a className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
//                          href="https://www.creative-tim.com/bootstrap-themes/free">Free Products
//                       </a>
//                     </li>

//                   </ul>
//                 </div>
//                 <div className="w-full lg:w-4/12 px-4">
//                   <span className="block uppercase text-gray-600 text-sm font-semibold mb-2">
//                     Other Resources
//                   </span>
//                   <ul className="list-unstyled">
//                     <li>
//                       <a className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
//                       href="https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md">MIT License
//                     </a>
//                     </li>
//                     <li>
//                       <a className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
//                          href="https://creative-tim.com/terms">Terms & Conditions
//                       </a>
//                     </li>
//                     <li>
//                       <a className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
//                          href="https://creative-tim.com/privacy">Privacy Policy
//                       </a>
//                     </li>
//                     <li>
//                       <a className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
//                          href="https://creative-tim.com/contact-us">Contact Us
//                       </a>
//                     </li>
//                   </ul>

//                 </div>
//               </div>
//             </div>
//           </div>
//           <hr className="my-6 border-gray-400" />
//           <div className="flex flex-wrap items-center md:justify-between justify-center">
//             <div className="w-full md:w-4/12 px-4 mx-auto text-center">
//               <div className="text-sm text-gray-600 font-semibold py-1">
//                 Copyright © {new Date().getFullYear()}{" "}Noctl
//               </div>
//             </div>
//           </div>
//         </div>
//       </footer>
//     </>
//   );
// }

function ThankYou() {
  return (
    <div>
      Thank you for subscribing!
    </div>
  )
}

function Form(onSubmit) {
  return (
    <>
      <p className="leading-relaxed mt-1 mb-4 text-gray-600">
        Signup and we'll let you know when we're ready.
      </p>
      <form action="https://gmail.us7.list-manage.com/subscribe/post?u=ac4059798e951a480d2ec5f4b&amp;id=bc470a9ff2" method="post" onSubmit={onSubmit}>
        <div className="relative w-full mb-3">
          <label
            className="block uppercase text-gray-700 text-xs font-bold mb-2"
            htmlFor="email"
          >
            Email
          </label>
          <input
            name="EMAIL"
            type="email"
            className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full"
            placeholder="Email"
            style={{ transition: "all .15s ease" }}
          />
        </div>
        <div id="mce-responses" className="text-center mt-6">
          <div id="mce-error-response" className="hidden"></div>
          <div id="mce-success-response" className="hidden"></div>
        </div>
        <div className="hidden" aria-hidden="true">
          <input type="text" name="b_ac4059798e951a480d2ec5f4b_bc470a9ff2" tabIndex={-1} readOnly value=""/>
        </div>
        <div className="text-center mt-6">
          <Button type="submit">
            Subscribe
          </Button>
        </div>
      </form>
    </>
  )
}

function Home() {
  const [subscribed, setSubscribed] = useState(false);

  return (
    <>
      <Navbar transparent />
      <main>
        <div className="relative pt-16 pb-32 flex content-center items-center justify-center"
            style={{
              minHeight: "75vh"
            }}>
          <div className="absolute top-0 w-full h-full bg-center bg-cover"
              style={{
                backgroundImage: `url('${ImageHero}')`
              }}>
            <span id="blackOverlay" className="w-full h-full absolute opacity-75 bg-black"></span>
          </div>

          <div className="container relative mx-auto">
              <div className="items-center flex flex-wrap">
                <div className="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
                  <div className="pr-12">
                    <h1 className="text-white font-semibold text-5xl">
                      Self-publishing made easy
                    </h1>
                    <p className="mt-4 text-lg text-gray-300">
                      Convert your books to epub, mobi, pdf, and more
                      for digital platforms. Use our polished templates or
                      customize your own. It's your choice.
                    </p>
                    <p className="mt-4 text-lg text-gray-300">
                      <a href="#signup">Join the beta.</a>
                    </p>
                  </div>
                </div>

              </div>
          </div>
          <div
            className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden"
            style={{ height: "70px", transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-gray-300 fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>
        </div>


        <section className="relative py-20">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
            style={{ height: "80px", transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-white fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>

          <div className="container mx-auto px-4">
            <div className="items-center flex flex-wrap">
              <div className="w-full md:w-4/12 ml-auto mr-auto px-4">
                <img
                  aria-hidden="true"
                  className="max-w-full rounded-lg shadow-lg"
                  src={ImageTool}
                  alt="Book"
                />
              </div>
              <div className="w-full md:w-5/12 ml-auto mr-auto px-4">
                <div className="md:pr-12">
                  <h3 className="text-3xl font-semibold">
                    Tools to make beautiful books
                  </h3>
                  <p className="mt-4 text-lg leading-relaxed text-gray-600">
                    You've put a lot of work into your books. Let's make it
                    easy to for yourself or your team to put them on any platform.
                    We accept:
                  </p>
                  <ul className="list-none mt-6">
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-pink-600 bg-pink-200 mr-3">
                            <i className="fas fa-fingerprint"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-gray-600">
                            DOC/DOCX
                          </h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-pink-600 bg-pink-200 mr-3">
                            <i className="fab fa-html5"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-gray-600">
                            RTF
                          </h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-pink-600 bg-pink-200 mr-3">
                            <i className="fab fa-html5"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-gray-600">
                            OTF
                          </h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-pink-600 bg-pink-200 mr-3">
                            <i className="far fa-paper-plane"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-gray-600">
                            Markdown
                          </h4>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="pb-20 relative block bg-gray-900">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
            style={{ height: "80px", transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-gray-900 fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>

          <div className="container mx-auto px-4 lg:pt-24 lg:pb-64">
            <div className="flex flex-wrap text-center justify-center">

            </div>
          </div>
        </section>
        <section className="relative block py-24 lg:pt-0 bg-gray-900">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap justify-center lg:-mt-64 -mt-48">
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-300">
                  <div className="flex-auto p-5 lg:p-10">
                    <h4 id="signup" className="text-2xl font-semibold">
                      Stay up to date
                    </h4>
                    {subscribed ? ThankYou() : Form(() => setSubscribed(true))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default Home
